import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import "./live-video.m.css";

const LiveVideo = ({ collection }) => {
  const [isHindi, setIsHindi] = useState(false);

  useEffect(() => {
    setIsHindi(global.location.host.includes("hindi"));
  }, []);

  return (
    <div styleName="wrapper" className="full-width-with-padding">
      <div styleName="video-wrapper">
        <div styleName="title-wrapper">
          <h3 styleName="subsection-title">
            {isHindi ? "कर्नाटक का जनादेश" : "Decoding the Karnataka Mandate"}
          </h3>
          <p styleName="border-bottom"></p>
        </div>
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${collection["associated-metadata"].video_id}`}
          title="YouTube video player"
          styleName="iframe"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
          allowFullscreen
        ></iframe>
      </div>
    </div>
  );
};

LiveVideo.propTypes = {
  collection: PropTypes.object
};

export { LiveVideo };
